import React from "react";
import { saveAs } from "file-saver";
import { Packer } from "docx";
import { DocumentCreator } from "./specGenerator";

export const calculateSpecWordDoc = (data) => {
	const documentCreator = new DocumentCreator();
	const doc = documentCreator.create([
		data.columns,
		data.attachmentsColumns,
		data.questionsTableData,
		data.basicDataTableData,
		data.attachmentsDataTableData,
		data.opponentsTableData,
		data.medicalExpertsTableData
	]);

	Packer.toBlob(doc).then(blob => {
		saveAs(blob, "Client specifications for ARAG Policy-Inception integration with _NAME_.docx");
	});
}
